export async function loadCourse(courseKey) {
  if (!courseKey) return null;

  try {
    const [
      exercisesMod,
      glossaryMod,
      metadataMod,
      sharedMod,
      aboutMod,
      audiofilesMod,
    ] = await Promise.all([
      import(`./courses/${courseKey}/exercises.js`),
      import(`./courses/${courseKey}/glossary.js`),
      import(`./courses/${courseKey}/metadata.js`),
      import(`./courses/${courseKey}/shared.js`).catch(() => null),
      import(`./courses/${courseKey}/about.js`).catch(() => null), // ✅ optional
      import(`./courses/${courseKey}/audiofiles.js`).catch(() => null), // ✅ optional

    ]);

    return {
      exercises: exercisesMod.default ?? exercisesMod.EXERCISES ?? [],
      GlossaryPanel: glossaryMod.default ?? null,
      AboutPanel: aboutMod?.default ?? null, // ✅ component
      metadata: metadataMod.default ?? metadataMod.METADATA ?? {},
      shared: sharedMod ?? {},
       audioMeta:
        audiofilesMod?.default ??
        audiofilesMod?.INTONATION_AUDIO_META_EN ??
        audiofilesMod?.AUDIO_META ??
        null,
    };
  } catch (err) {
    console.warn(`[loadCourse] missing course "${courseKey}"`, err);
    return null;
  }
}
